
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/usabilitychecklist",
      function () {
        return require("private-next-pages/download/usabilitychecklist/index.tsx");
      }
    ]);
  